import { systemOperationModeApi } from "../../api";

/**
 * ⚙️ SystemOperationModeService
 * ------------------------------------------------------------
 * Maneja las operaciones del endpoint:
 * `/api/settings/system-operation-mode`
 *
 * Métodos disponibles:
 * - getActive → obtiene la configuración actual activa
 * - create → registra nueva configuración
 * - update → actualiza configuración existente
 */
const SystemOperationModeService = {
  /**
   * 🔍 Obtiene la configuración activa del sistema.
   * GET /api/settings/system-operation-mode/active
   */
  getActive: async () => {
    const response = await systemOperationModeApi.fetchCustom("/active");
    return response.data;
  },

  /**
   * 💾 Crea una nueva configuración de modo de operación.
   * POST /api/settings/system-operation-mode
   */
  create: async (payload: any) => {
    const response = await systemOperationModeApi.add(payload);
    return response.data;
  },

  /**
   * ♻️ Actualiza una configuración existente.
   * PUT /api/settings/system-operation-mode/{id}
   */
  update: async (id: number, payload: any) => {
    const response = await systemOperationModeApi.modify(id, payload);
    return response.data;
  },
};

export default SystemOperationModeService;
